package org.ksdfv.thelema.utils

import kotlin.native.concurrent.ThreadLocal

/** @author zeganstyl */
@ThreadLocal
object LOG: ILog {
    lateinit var proxy: ILog

    override var infoEnabled: Boolean
        get() = proxy.infoEnabled
        set(value) { proxy.infoEnabled = value }

    override var debugEnabled: Boolean
        get() = proxy.debugEnabled
        set(value) { proxy.debugEnabled = value }

    override var errorEnabled: Boolean
        get() = proxy.errorEnabled
        set(value) { proxy.errorEnabled = value }

    override fun info(message: String, exception: Throwable?, tag: String) =
        proxy.info(message, exception, tag)

    override fun debug(message: String, exception: Throwable?, tag: String) =
        proxy.debug(message, exception, tag)

    override fun error(message: String, exception: Throwable?, tag: String) =
        proxy.error(message, exception, tag)
}